export enum SidebarActionTypes {    
  SET_SIDEBAR_SHOW = "@@sidebar/SET_SIDEBAR_SHOW"
}

export type SidebarAction = { type: SidebarActionTypes.SET_SIDEBAR_SHOW, data: boolean }

export const setSidebarShow = (show: boolean): SidebarAction => {
  return {
      type: SidebarActionTypes.SET_SIDEBAR_SHOW,
      data: show
  }
}
